(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.now_blocks = {
    attach: function(context, settings) {
      // Initialize featured content block behavior
      jQuery('.block-nowfoods-featured-content-block', context).once('featured-content-block').each(function() {
        jQuery(this)
          .on('mouseenter', function() {
            jQuery(this).addClass('focus');
          })
          .on('mouseleave', function() {
            jQuery(this).removeClass('focus');
          });
      });

      // Initialize show more block behavior
      jQuery('.block-nowfoods-read-more-block .show-more-block-body', context).once('show-more-block').each(function() {
        const $content = jQuery(this);
        const maxHeight = parseInt($content.css('max-height'));
        const scrollHeight = $content.get(0).scrollHeight;

        if (scrollHeight <= maxHeight) {
          $content.removeClass('collapse');
          $content.parent().find('.show-more-block-toggle').hide();
        }
      });
    }
  };
})(jQuery, Drupal);
